import { inject, Injectable } from '@angular/core';

import { DialogRef, DialogService } from '@hglobal/fin-ui';

import { WalletCard } from '@kr/models';

import { MassPayOutDetailsComponent } from './mass-pay-out-details.component';
import { MassPayOut } from '../../models';

@Injectable()
export class MassPayOutDetailsDialog {
  readonly #dialog = inject(DialogService);

  open(wallet: WalletCard, massPayOut: MassPayOut): DialogRef {
    return this.#dialog.open(MassPayOutDetailsComponent, { wallet, massPayOut });
  }
}
